import { EdgeSystemStatus } from "./edgeUser";

export interface ValidationResult {
    displayName: boolean;
    vesselName: boolean;
    licenseNumber: boolean;
    email: boolean;
    rank: boolean;
    otp: boolean;
    password: boolean;
    userInfo: boolean;
    any: boolean;
};

export enum EdgeSystemType {
    None = 0,
    DataSync = 1,
    LogSync = 2,
    CloudConnection = 3,
    CloudAuth = 4
};

export interface EdgeSystemState {
    id: string;
    systemType: EdgeSystemType;
    status: EdgeSystemStatus;
    lastSuccessfulTimeUtc: string | null;
};

export type SystemState = {
    [key in EdgeSystemType]: EdgeSystemState
};
